export default __webpack_public_path__ + "static/media/Coot026.49b1ca72.jpg";